module.exports = __webpack_public_path__ + "static/media/shopping-basket-icon.63b909d3.svg";